const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_4asDkKofb',
      userPoolClientId: '3gj1rrk6ore42q695os8ls6cgf',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      },
    },
  },
};

export default awsConfig;
